<template lang="pug">
  div.h-100
    app-header(title='Register', noBack)
    transition(name="down", mode="out-in")
      div.wizard-body.bg-light.h-100(v-if='showWizard')
        .container.h-100.pt-4
          b-carousel.h-100(id="carouselWizard", ref='carouselWizard', :no-touch="true", :interval="0", v-model="slideIndex")
            b-carousel-slide
              template(v-slot:img="")
                .container
                  b-form(v-on:submit.prevent='onSubmit()')
                    b-form-group
                        label Firstname
                        b-form-input(name='given-name', type='text', v-model='inputForm.firstname', required='', placeholder='firstname', autocomplete="given-name")
                    b-form-group
                        label Lastname
                        b-form-input(name='family-name', type='text', v-model='inputForm.lastname', required='', placeholder='lastname', autocomplete="family-name")
                    b-form-group
                      label Phone
                      b-form-input(type='tel', v-model='inputForm.phone', required='', pattern="\\d{10}", title='10 Digits only. No +27 or spaces please :)', placeholder='Format 0825555555', autocomplete="tel")
                    b-button(type='submit', v-show="false", ref='submit0')
            b-carousel-slide
              template(v-slot:img="")
                b-form(v-on:submit.prevent='onSubmit()')
                  .container
                    b-form-group
                      label Street address
                      b-form-input(type='text', v-model='inputForm.address_line1', required='', placeholder='Street', autocomplete="address-line1")
                      b-form-checkbox(v-model='inApartment') Apartment
                    b-collapse(v-model="inApartment")
                      b-form-group(v-if="inApartment")
                        label Appartment
                        b-form-input(type='text', v-model='inputForm.address_line2', placeholder='Complex and apartment number', autocomplete="address-line2")
                    .row
                      .col-6
                        b-form-group
                          label Suburb
                          b-form-input(type='text', v-model='inputForm.suburb', required='', placeholder='Suburb')
                      .col-6
                          b-form-group
                            label City
                            b-form-input(type='text', v-model='inputForm.city', required='', placeholder='City', autocomplete="city")
                      .col-6
                          b-form-group
                            label Zip
                            b-form-input(type='number', v-model='inputForm.zip', max='999999', required='', placeholder='Zip Code', autocomplete="postal-code")
                  b-button(type='submit', v-show="false", ref='submit1')
            b-carousel-slide
              template(v-slot:img="")
                b-form(v-on:submit.prevent='onSubmit()')
                  .container
                    b-form-group
                      label Email
                      b-form-input(type='email', v-model='inputForm.email', required='', placeholder='email', autocomplete="email")
                    b-form-group
                      label Password
                      b-form-input(type="password", name="password", v-model="inputForm.password", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                    b-form-group
                      label Repeat
                      b-form-input(type="password", name="password2", v-model="passwordRepeat", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                  b-button(type='submit', v-show="false", ref='submit2')
                p Password must be atleast 8 characters, with a number and a capital letter.
            b-carousel-slide
              template(v-slot:img="")
                .container.pt-5.text-center
                  loader(size="md")
                  div.text-center
                    h4 Doing some laundro-math...
                    p Hold tight!
    b-button#btn-bar.btn-theme(type='submit', :disabled="slideIndex == 3", @click="$refs[`submit${slideIndex}`].click()")
      h3.m-0.text-light(v-if="slideIndex == 2") Register
      h3.m-0.text-light(v-else="") Next
      b-progress(:value="slideIndex", :max="3")
</template>

<script>

// import Vue from 'vue';
import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';
import AppHeader from '@/components/structure/AppHeader';

export default {
  name: 'formWizard',
  components: {
    AppHeader,
  },
  mixins: [standardMix],
  data() {
    return {
      showWizard: false,
      inApartment: false,
      passwordRepeat: '',
      slideIndex: 0,
      inputForm: {
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        address_line1: '',
        address_line2: '',
        suburb: '',
        city: '',
        zip: '',
        password: '',
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('order', ['addOrder']),
    onSubmit() {
      this.$refs.carouselWizard.next();
      if (this.slideIndex === 2) {
        if (this.inputForm.password === this.passwordRepeat) {
          try {
            this.busy();
            // (optional) Wait until recaptcha has been loaded.
            // await this.$recaptchaLoaded();
            // Execute reCAPTCHA with action "login".
            // const token = await this.$recaptcha('login');
            // const token = 'myth';
            // this.$gtm.trackEvent({
            //   event: null, // Event type [default = 'interaction'] (Optional)
            //   category: 'Page Clicks',
            //   action: 'Click',
            //   label: 'btnSubmitOrder',
            //   noninteraction: false, // Optional
            // });
            this.addOrder(this.inputForm);
          } catch (error) {
            this.error(error);
          }
        } else {
          this.goBack();
          this.error('Passwords do not match');
        }
      }
    },
    goBack() {
      if (this.slideIndex > 0) {
        this.$refs.carouselWizard.prev();
      }
    },
  },
  created() {
    // Reset carousel
    this.slideIndex = 0;
    // Pre-populate values here
  },
  mounted() {
    // Create animation effect
    setTimeout(() => { this.showWizard = true; }, 100);
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  z-index: 1000;
  background-color: white;
  border-radius: 15px 15px 0 0;
}
#btn-bar{
  cursor: pointer;
  position: fixed;
  bottom: 1px;
  left: 0;
  width: 100%;
  z-index: 10;
  width: 100%;
  padding: 30px;
  margin: 0;
  &:focus {
    background-color: $primary !important;
  }
  .progress {
    // background-color: black;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    border-radius: 0 !important;
    height: 10px;
  }
}
  .carousel-indicators > li {
    background-color: blue !important;
  }

  .down-enter-active, .page-leave-active {
    transition: transform 0.5s;
  }
  .down-enter {
    transform: translateY(100%);
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Register.vue